/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { db } from "./utils/firebase";
import { makeStyles } from "@material-ui/core/styles";
// import Link from "../src/Link";
import Typography from "@material-ui/core/Typography";
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles((theme) => ({
  tags: {
    listStyle: 'none',
    margin: 0,
    marginTop: 10,
    padding: 0,
    whiteSpace: 'nowrap',
    overflowX: 'scroll',
    '&::-webkit-scrollbar': {
      height: 10
    },
    '&::-webkit-scrollbar-track': {
      background: 'rgba(255,255,255,1)',
      borderRadius: 5,
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(26,42,54,.15)',
      borderRadius: 5,
    },
  },
  tagsWrapped: {
    listStyle: 'none',
    margin: 0,
    marginTop: 10,
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'nowrap',
      overflowX: 'scroll',
      '&::-webkit-scrollbar': {
        height: 10
      },
      '&::-webkit-scrollbar-track': {
        background: 'rgba(255,255,255,1)',
        borderRadius: 5,
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(26,42,54,.15)',
        borderRadius: 5
      },
    },
  },
  titleTag: {
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.02857em'
  },
  tag: {
    display: 'inline-block',
    marginRight: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
  hash: {
    backgroundColor: 'inherit',
    fontWeight: 'bold'
  }
}));

const TagList = (props) => {
  const { tagIds, wrapped, ...other } = props;

  const classes = useStyles();

  const [tags, setTags] = useState([]);

  useEffect(() => {
    let query = db.collection('tags')
        .where('source', 'in', ['event', 'game', 'team', 'player', 'week', 'season', 'league', 'user'])
        .orderBy('count', 'desc')
        .orderBy('priority')
        .limit(10);

    if (tagIds && tagIds.length > 0) {
      query = db.collection('tags')
        .where("slug", "in", tagIds)
        .where("priority", "<", 999) // no author, title, or description tags
        .orderBy("priority");
    }

    query.get().then((results) => setTags(results.docs));
  }, [])

  return (
    <Typography component="ul" className={wrapped ? classes.tagsWrapped : classes.tags} { ...other }>
      { !tagIds && (
          <li key={0} className={classes.tag}>
            <Chip label="Trending" color="primary" className={classes.titleTag} />
          </li>
      )}
      { tags.map((tag, i) => {
        return (
          <li key={i+1} className={classes.tag}>
            <Chip
              avatar={<Avatar className={classes.hash} style={{ marginRight: -12, width: 15 }}>#</Avatar>}
              label={tag.get('name')}
              component="a"
              clickable
              href={`/tags/${tag.get('slug')}`}
            />
          </li>
        );
      })}
    </Typography>
  );
};

export default TagList;
